import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/services/alert.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import swal from 'sweetalert2';
import { ExcelService } from 'src/app/services/excel.service';
import { UserService } from 'src/app/services/user.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { RoleType } from 'src/enum/roletype';
import * as _ from 'lodash';
import { SecurityService } from 'src/app/services/security.service';

@Component({
  selector: 'app-paccsuser',
  templateUrl: './paccsuser.component.html',
  styleUrls: ['./paccsuser.component.scss']
})
export class PaccsuserComponent implements OnInit {
  data = [];
  // public data: any[];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    'fullName',
    'roleName',
    'email',
    'mobileNo',
    // 'status',
    'actions'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  regionId: any;
  divisionId: any;
  subdivisionId: any;
  controlAccess: any;
  districtId: any;
  blockId: any;
  villageId: any;
  gramPanjayatId: any;
  loading: boolean = false;
  form: FormGroup
  blockList: any;
  filterblockList: any;
  villageList: any;
  filtervillageList: any;
  panchayatcList: any;
  filterpanchayatcList: any;
  disId: any
  role: number;
  public RoleEnumType = RoleType
  isCheckedTrue: boolean = false;
  districtList: any;
  filterListdistrict: any;
  PaccsType: any;
  districtDisabled: boolean;
  blockIdDisabled: boolean;
  villageDisabled: boolean;
  gramPanchayatDisabled: boolean;


  constructor(public navigationService: NavigationService,
    private userSessionService: UserSessionService,
    private excelService: ExcelService,
    private translate: TranslateService,
    private userService: UserService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cashBookingService: CashBookingService,
    public dialog: MatDialog,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    // public dialogRef: MatDialogRef<PaacsComponent>,
    private usersessionService: UserSessionService,
    private securityService: SecurityService,
  ) {
    this.regionId = this.userSessionService.getFilterregionId();
    this.divisionId = this.userSessionService.getFilterDivisionId();
    this.subdivisionId = this.userSessionService.getFilterSubDivisionId();

    this.controlAccess = this.userSessionService.getPageUrl(this.router.url);
    this.districtId = parseInt(this.userSessionService.getUserdistrictId());
    this.blockId = parseInt(this.userSessionService.getUserBlockId());
    this.villageId = parseInt(this.userSessionService.getUserVillageId());
    this.gramPanjayatId = parseInt(this.userSessionService.getUserGramPanjayatId());
    // this.disId = this.data.districtId;
    // this.PaccsType = this.data.paccsType
    this.role = this.usersessionService.roleId()
  }

  ngOnInit(): void {
    this.initialValidators();
    this.route.queryParamMap.subscribe((paramMap: ParamMap) => {
      this.regionId = this.userSessionService.getFilterregionId();
      this.divisionId = this.userSessionService.getFilterDivisionId();
      this.subdivisionId = this.userSessionService.getFilterSubDivisionId();
      this.districtId = parseInt(this.userSessionService.getUserdistrictId());
      this.blockId = parseInt(this.userSessionService.getUserBlockId());
      this.villageId = parseInt(this.userSessionService.getUserVillageId());
      this.gramPanjayatId = parseInt(this.userSessionService.getUserGramPanjayatId());
      this.getDistrict();
      this.get(true);
    });
  }

  initialValidators() {
    this.form = this.formBuilder.group({
      districtId: [0,],
      block: [0,],
      village: [0,],
      panchayat: [0,]
    })
  }


  getDistrict() {
    this.cashBookingService.districtData(1, true).subscribe(result => {
      if (result) {
        this.districtList = result;
        this.filterListdistrict = this.districtList.slice();
        if (this.districtList.length === 1) {
          this.form.controls['districtId'].setValue(this.districtList[0].key);
          this.districtDisabled = true;
          this.getBlock();
          this.get(true);

        }
        if (this.districtId !== 0) {
          this.form.controls['districtId'].setValue(this.districtId);
          this.districtDisabled = true;
          this.getBlock();
          this.get(true);

        }
      }
    });
    this.get(true);

  }

  districtchange(event) {
    this.getBlock();
    this.get(true);
  }
  getBlock() {
    this.cashBookingService.getLookUpblockbyId(this.form.value.districtId, 1, true).subscribe(res => {
      this.blockList = res
      this.filterblockList = this.blockList.slice();
      if (this.filterblockList.length === 1) {
        this.form.controls['block'].setValue(this.filterblockList[0].key)
        this.blockIdDisabled = true;
        this.blockChange();
        this.get(true);

      }
      if (this.blockId) {
        this.form.controls['block'].setValue(this.blockId)
        this.blockIdDisabled = true;
        this.blockChange();
        this.get(true);

      }
    })
    this.get(true);

  }
  blockChange() {
    this.form.controls['village'].setValue(null);
    this.form.controls['panchayat'].setValue(null);
    this.panchayatcList = [];
    this.filterpanchayatcList = [];
    this.villageList = [];
    this.filtervillageList = []
    this.cashBookingService.getvillageList(this.form.value.block, 1, true).subscribe(res => {
      this.villageList = res;
      this.filtervillageList = this.villageList.slice()
      if (this.filtervillageList.length === 1) {
        this.form.controls['village'].setValue(this.filtervillageList[0].key)
        this.villageDisabled = true;
        this.villageChange();
        this.get(true);

      }
      if (this.villageId) {
        this.form.controls['village'].setValue(this.villageId)
        this.villageDisabled = true;
        this.villageChange();
        this.get(true);
      }
    })
    this.get(true);
  }

  villageChange() {
    this.panchayatcList = [];
    this.filterpanchayatcList = [];
    this.form.controls['panchayat'].setValue(null);
    this.cashBookingService.gramPanchayatLookUp(this.form.value.village, true).subscribe(res => {
      this.panchayatcList = res;
      this.filterpanchayatcList = this.panchayatcList.slice();
      if (this.filterpanchayatcList.length === 1) {
        this.form.controls['panchayat'].setValue(this.filterpanchayatcList[0].key)
        this.gramPanchayatDisabled = true;
      }
      if (this.gramPanjayatId) {
        this.form.controls['panchayat'].setValue(this.gramPanjayatId)
        this.gramPanchayatDisabled = true;
      }

    })
    this.get(true);
  }


  get(refresh: boolean) {
    this.loading = true
    const data = {
      districtId: this.form.value.districtId ? this.form.value.districtId : 0,
      blockId: this.form.value.block ? this.form.value.block : 0,
      villageId: this.form.value.village ? this.form.value.village : 0,
      gramPanchayatId: this.form.value.panchayat ? this.form.value.panchayat : 0,
    }
    this.userService.getpaccsuser(data, refresh).subscribe(result => {
      this.loading = false
      this.data = result;
      this.data = _.orderBy(this.data, ['id'], ['desc']);
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onRefresh() {
    this.searchInput.nativeElement.value = '';
    this.form.controls['districtId'].setValue(0);
    this.form.controls['block'].setValue(0);
    this.form.controls['village'].setValue(0);
    this.form.controls['panchayat'].setValue(0);

    this.get(true);
  }

  goToAction(id: number, actionInfo: number) {
    const encId = this.securityService.encrypt(id);
    this.navigationService.goToPACCSuser(encId, actionInfo);
  }

  OnDelete(id: number, fullName: any, status: number) {
    if (status === 1) {
      const msgstring = this.translate.instant('Youwanttoactive');
      this.deleteMenu((msgstring + ' ' + fullName + '?'), id, status);
    } else {
      const msgstring = this.translate.instant('Youwanttodeactive');
      this.deleteMenu((msgstring + ' ' + fullName + '?'), id, status);
    }
  }

  deleteMenu(message: string, id: number, status: number) {
    const title = status === 1 ? this.translate.instant('ActivateConfirmation') : this.translate.instant('DeactivateConfirmation');
    const Yes = this.translate.instant('Yes');
    const No = this.translate.instant('No');
    swal.fire(
      {
        title,
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }
    )
      .then(res => {
        if (res.value) {
          this.userService.delete(id, status).subscribe(result => {
            if (result) {
              const msg1 = status === 1 ? this.translate.instant('Activated Successfully') : this.translate.instant('Deactivated Successfully');
              const msg3 = this.translate.instant('User');
              this.alertService.result(result, false, msg3 + ' ' + msg1);
              this.get(true);
            }
          });
        }
      });
  }


  openResetPassword(email) {
    // const title = status === 1 ?  this.translate.instant('ActivateConfirmation') : this.translate.instant('DeactivateConfirmation');
    const title = this.translate.instant('Confirmation');
    const Yes = this.translate.instant('Yes');
    const No = this.translate.instant('No');
    const text = this.translate.instant('Are you sure you want to Reset Password?');
    swal.fire(
      {
        title,
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }
    )
      .then(res => {
        if (res.value) {
          const username = {
            username: email
          }
          this.userService.forgotpasswordUser(username).subscribe(result => {
            if (result && result.isSuccess) {
              this.alertService.success('Password has been reset successfully');
            } else {
              this.alertService.error(result.htmlFormattedFailures);
            }
          });
        }
      });
  }
  onExportExcel() {
    const excelData = [];
    const excelColumns = [
      'Full Name',
      'Email',
      'Mobile No',
    ];

    if (this.data) {
      this.data.forEach((element) => {
        excelData.push({
          fullName: element.fullName,
          email: element.email,
          mobileNo: element.mobileNo,
        });
      });

      this.excelService.exportAsExcelFile(excelData, 'Devices Report', excelColumns);
    }
  }

}
